import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { verificateRejectSchedules } from "../../actions/medical_actions";
import moment from "moment";
import "moment/locale/es";
import { permissionsValidate } from "../../functions";

moment.locale("es");
let offices = (props) => {
  const [state, setstate] = useState(props.data);
  const [select, setselect] = useState(null);
  const [permissions, setpermissions] = useState([]);

  useEffect(() => {
    if (permissions.length === 0) {
      let searchModule = permissionsValidate(props.permissions, "schedule");
      if (searchModule >= 0)
        setpermissions(props.permissions[searchModule].action);
    }

    let resultMedical = props.medicalList.find((value) => {
      return value._id === state.medical.medical_presenter.medical_id;
    });
    if (select !== null) {
      setstate(resultMedical);
      setselect(null);
    }
  }, [props.medicalList]);
  const actionsOffice = (value, status) => {
    setselect(value);
    let type;
    switch (status) {
      case "verificated":
        type = "reject";
        break;
      case "rejected":
        type = "verificate";

        break;
      default:
        break;
    }

    props.verificateRejectSchedules(
      value,
      state.medical.medical_presenter.medical_id,
      type
    );
  };

  function sort(a, b) {
    a = a.week_day._id;
    b = b.week_day._id;
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  }
  state.medical.schedules.sort(sort);

  return (
    <div>
      <Table responsive="xl">
        <thead>
          <tr>
            <th>Día</th>
            <th>Hora</th>
            <th>Consultorio</th>
            <th>Especialidad</th>
            <th>Estatus</th>
            {(permissions.includes("verificate") ||
              permissions.includes("reject")) && <th>Acción</th>}
          </tr>
        </thead>
        <tbody>
          {state &&
            state.medical &&
            state.medical.schedules.map((value, index) => {
              let status;

              switch (value.status) {
                case "verificated":
                  status = "Verificado";
                  break;
                case "rejected":
                  status = "Rechazado";
                  break;
                default:
                  status = "Sin verificar";
                  break;
              }

              return (
                <tr key={index}>
                  <td>{value.week_day.es.name}</td>
                  <td>
                    {value.hours.map((hour, indexHour) => (
                      <tr key={indexHour}>
                        <td>
                          {moment(hour.start, "  hh:mm A").format("hh:mm A")} -
                          {moment(hour.end, "  hh:mm A").format("hh:mm A")}
                        </td>
                      </tr>
                    ))}
                  </td>
                  <td>{value.office.name}</td>
                  <td>{value.specialties[0].name.es}</td>
                  <td>{status}</td>

                  <td>
                    <tr>
                      {permissions.includes("reject") &&
                        value.status !== "rejected" && (
                          <td>
                            <button
                              className={"btn btn-sm btn-danger "}
                              onClick={() =>
                                actionsOffice(value, "verificated")
                              }
                            >
                              Rechazar
                            </button>
                          </td>
                        )}

                      {permissions.includes("verificate") &&
                        value.status !== "verificated" && (
                          <td>
                            <button
                              className={"btn btn-sm  btn-success "}
                              onClick={() => actionsOffice(value, "rejected")}
                            >
                              Verificar
                            </button>
                          </td>
                        )}
                    </tr>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  permissions: state.user.user.user.permissions,
  medicalList: state.medical.medicalList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ verificateRejectSchedules }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(offices);
